import { withStyles } from "@material-ui/core/styles";
import MailOutlineIcon from "@material-ui/icons/MailOutline";

const styles = (theme) => ({
  displayMessage: {
    display: "flex",
    paddingRight: 8,
  },
  dispatchMessage: {
    fontSize: "20px",
    cursor: "pointer",
  },
});

const Message = ({ classes, onClick }) => {
  return (
    <div className={classes.displayMessage}>
      <MailOutlineIcon
        className={`${classes.dispatchMessage} tableCellName`}
        onClick={onClick}
      />
    </div>
  );
};

export default withStyles(styles)(Message);
